import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { ToastData } from "./toastTypes";
export type { ToastData, ToastKind, ToastPayloadMap } from "./toastTypes";
export { toast } from "./toastTypes";

export type ToastState = { queue: ToastData[]; dismissed: string[] }

const initialState: ToastState = { queue: [], dismissed: [] }

const toastSlice = createSlice({
  name: 'toast',
  initialState,
  reducers: {
    showToast: (state, action: PayloadAction<ToastData>) => {
      const { id } = action.payload;
      if (state.queue.some(t => t.id === id) || state.dismissed.includes(id)) return;
      state.queue.push(action.payload);
    },

    dismissToast: (state, action: PayloadAction<string>) => {
      const id = action.payload;
      state.queue = state.queue.filter(t => t.id !== id);
      if (!state.dismissed.includes(id)) {
        state.dismissed.push(id);
      }
    },
  },
})

export const { showToast, dismissToast } = toastSlice.actions

export default toastSlice.reducer
